import URLConfig from '../config/URLConfig'
// 判断两个对象/数据是否完全一致
// 获取当前10位时间戳
function getTimeStamp() {
      // 1. 生成时间文件名
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const fileName = `${year}-${month}-${day} ${hours}_${minutes}_${seconds}`;
    return fileName;
}
function deepEqual(a, b) {
  // 基础类型直接对比
  if (a === b) return true

  // 类型不一致直接不等
  if (typeof a !== 'object' || typeof b !== 'object' || a == null || b == null) {
    return false
  }

  // 数组判断
  const aIsArr = Array.isArray(a)
  const bIsArr = Array.isArray(b)
  if (aIsArr !== bIsArr) return false

  // 数组长度不一致
  if (aIsArr && a.length !== b.length) return false

  // 对象键数量不一致
  const keysA = Object.keys(a)
  const keysB = Object.keys(b)
  if (!aIsArr && keysA.length !== keysB.length) return false

  // 递归遍历每一项对比
  for (let key in a) {
    if (!deepEqual(a[key], b[key])) {
      return false
    }
  }
  return true
}
const array = {
    /**
     * 提取数组对象指定字段并拼接为字符串
     * @param {Array} arr 源数组
     * @param {string} key 要提取的字段名
     * @param {string} [separator=','] 分隔符，默认逗号
     * @returns {string} 拼接后的字符串
     */
    getFieldStr(arr, key, separator = ',') {
        if (!Array.isArray(arr) || arr.length === 0) return '';

        return arr
            .map(function (item) {
            // 移除可选链，兼容低版本浏览器/Babel
            return item && item[key];
            })
            .filter(function (val) {
            return val != null;
            })
            .join(separator);
    },
    /**
     * 带逗号的字符串转数组并过滤空值
     * @param {string} str - 带逗号的字符串
     * @param {boolean} toNumber - 是否转为数字数组
     * @returns {Array} 处理后的数组
     */
    commaStrToArray(str, toNumber = false) {
        // 1. 如果入参是数组，直接返回原数组（不修改）
        if (Array.isArray(str)) {
            return str;
        }
        //2.过滤空字符串
        if(str === undefined || str === null|| str === '')return[];
        const arr = str.split(',').filter(item => item.trim() !== '');
        return toNumber ? arr.map(Number) : arr;
    },
    
    /**
     * 对比两个对象数组，将待添加数组中ID不存在于目标数组的对象添加进去
     * @param {Array} targetArr - 目标数组（最终要添加对象的数组）
     * @param {Array} addArr - 待添加的对象数组（来源数组）
     * @param {string} idKey - ID字段名（默认'id'，可自定义如'userId'）
     * @returns {Array} 合并后的新数组（不修改原数组，返回新数组）
     */
    mergeArrByUniqueId(targetArr = [], addArr = [], idKey = 'id') {
    // 1. 深拷贝目标数组，避免修改原数组
    const newTargetArr = JSON.parse(JSON.stringify(targetArr));
    // 2. 提取目标数组的ID集合（转字符串，兼容数字/字符串ID）
    const targetIdSet = new Set(
      newTargetArr
        .filter(item => item && item[idKey] != null) // 过滤无ID的无效对象
        .map(item => item[idKey].toString())
    );
  
    // 3. 遍历待添加数组，添加ID不存在的对象
    addArr.forEach(item => {
      // 跳过无ID的无效对象
      if (!item || item[idKey] == null) return;
      const currentId = item[idKey].toString();
      // 若ID不存在，则添加
      if (!targetIdSet.has(currentId)) {
        newTargetArr.push(JSON.parse(JSON.stringify(item))); // 深拷贝避免引用关联
        targetIdSet.add(currentId); // 更新ID集合，防止重复添加
      }
    });
    return newTargetArr;
  },
  /**
  * 两个对象数组根据 ID 合并
  * @param {Array} arrA - 目标数组（最终要添加对象的数组）
  * @param {Array} arrB - 待添加的对象数组（来源数组）
  * @param {string} idKey - ID字段名（默认'id'，可自定义如'userId'）
  * @returns {Array} 合并后的新数组（不修改原数组，返回新数组）
  */
  mergeArrById(arrA, arrB, idKey = 'id') {
    const map = new Map()
    // 先存A
    arrA.forEach(item => map.set(item[idKey], {...item}))
    // 遍历B，存在就合并，不存在新增
    arrB.forEach(item => {
      if (map.has(item[idKey])) {
        map.set(item[idKey], {...map.get(item[idKey]), ...item})
      } else {
        map.set(item[idKey], {...item})
      }
    })
    return [...map.values()]
  },
  /**
   * 将对象中所有数组属性转为逗号分隔的字符串（仅处理第一层）
   * @param {Object} obj - 源对象
   * @param {string} separator - 分隔符，默认 ','
   * @param {string[]} excludeKeys - 不需要转换的key数组，默认空
   * @returns {Object} 处理后的新对象（不修改原对象）
   */
  convertObjArrayToStr(obj, separator = ',', excludeKeys = []) {
      // 防御：非对象直接返回
      if (typeof obj !== 'object' || obj === null || Array.isArray(obj)) {
          return obj;
      }
      // 拷贝新对象，不污染原数据
      const newObj = JSON.parse(JSON.stringify(obj));

      // 遍历所有属性
      for (const key in newObj) {
          // 当前key在排除列表里，跳过不处理
          if (excludeKeys.includes(key)) continue;

          const value = newObj[key];
          // 判断是否为数组
          if (Array.isArray(value)) {
              newObj[key] = value.length > 0 ? value.join(separator) : '';
          }
      }
      return newObj;
  },
    /**
     * base64格式PDF下载
     * @param {String} base64Str pdf的base64编码（带data:application/pdf;base64, 前缀）
     * @param {String} fileName
     */
    downloadPdfByBase64(base64Str, fileName = "文件.pdf") {
        const timeStamp = getTimeStamp();
      // 截取base64本体，去掉头部标识
      const base64 = base64Str.split(";base64,")[1];
      // base64转Blob
      const byteString = atob(base64);
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < byteString.length; i++) {
        uint8Array[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([arrayBuffer], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = `${timeStamp}_${fileName}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(blobUrl);
    },
    /**
     * 网络URL下载PDF（处理跨域、普通链接）
     * @param {String} url pdf网络地址
     * @param {String} fileName 文件名，如：报告.pdf
     */
    downloadPdfByUrl(url, fileName = ".pdf") {
      let fullUrl = URLConfig.QINIU_URL + url;
      const timeStamp = getTimeStamp();
      // 编码文件名，防止中文乱码
      const encodeName = encodeURIComponent(`${timeStamp}_${fileName}`)
      // 拼接下载标识
      fullUrl += `?attname=${encodeName}`
      const aTag = document.createElement("a");
      aTag.href = fullUrl;
      aTag.download = fileName;
      document.body.appendChild(aTag);
      aTag.click();
      aTag.remove();
    },
}

export default {
  ...array,
  deepEqual:deepEqual
};
